
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 62 50"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"none","fill-rule":"evenodd"}},[_c('rect',{attrs:{"width":"47.783","height":"47.783","x":"1","y":"1","stroke":"#FFF","rx":"7"}}),_c('path',{attrs:{"fill":"#FFF","d":"M19.542 17.5l.006 12.41 5.857-.006-.56 2.596h-8.34l-.005-2.59V17.506l3.042-.006zm13.448 3.16c.177 0 .278.054.278.334v2.738h-.004a4.083 4.083 0 00-.498-.034c-.602 0-1.778.156-2.883 1.2V32.5l-3.04.001-.005-11.538 2.444-.006c.394.371.52.96.604 1.483 0-.02.66-1.148 1.89-1.589a3.784 3.784 0 011.191-.19h.023z"}}),_c('rect',{attrs:{"width":"22.891","height":"22.891","x":"37.622","y":"5.896","fill":"#121212","stroke":"#FFF","rx":"5"}}),_c('path',{attrs:{"fill":"#BF9C5F","fill-rule":"nonzero","d":"M42.135 12.524h2.751a2.141 2.141 0 004.132 0h7.033a.535.535 0 100-1.07h-7.033a2.141 2.141 0 00-4.132 0h-2.75a.535.535 0 100 1.07zm4.817-1.606a1.07 1.07 0 110 2.14 1.07 1.07 0 010-2.14zm9.1 11.24h-7.033a2.141 2.141 0 00-4.132 0h-2.751a.535.535 0 100 1.071h2.75a2.141 2.141 0 004.133 0h7.033a.535.535 0 100-1.07zm-9.1 1.606a1.07 1.07 0 110-2.14 1.07 1.07 0 010 2.14zm9.1-6.958H53.3a2.141 2.141 0 00-4.132 0h-7.033a.535.535 0 100 1.07h7.033a2.141 2.141 0 004.132 0h2.75a.535.535 0 100-1.07zm-4.818 1.606a1.07 1.07 0 110-2.14 1.07 1.07 0 010 2.14z"}})])])
          )
        }
      }
    